import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Container, Tab, Nav, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import All from "./All";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import { RouterContext } from "../Onboarding";

export default function PPCDashboardCustomizationAll(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  const [validated, setValidatation] = useState(false);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();

  const [showBoxes, setShowBoxes] = useState(false);
  let chevronLeft = require("images/onboarding/chevronLeft.png");
  chevronLeft = <img style={{ paddingBottom: "3px", paddingRight: "7px" }} src={`/datapulse${chevronLeft}`} />;
  const backTooltip = (props) => (
    <Tooltip {...props}>
      You cannot return to the previous page and change your config, but after finishing onboarding, you can adjust your dashboards under configs.
    </Tooltip>
  );
  return (
    <Container fluid className="px-xl-5 px-1">
      <Row className="px-xl-4 px-1 mb-3 pb-3 justify-content-center">
        <Col md={10}>
          <Row className=" mb-1  justify-content-center">
            <Col md={9}>
              <div>
                <p className="pb-3 f28 visby-bold primary text-center">PPC Dashboard Customization - All</p>
              </div>
              <div>
                <p className=" f16 nunito-regular  primary ">Would you like to customize your PPC dashboards now or use the default settings?</p>
              </div>
            </Col>
          </Row>

          <Row className=" mb-3 pb-3 justify-content-center">
            <Col md={9}>
              <div className="pb-1 pt-2">
                <CustomTooltip
                  faClass="far fa-question-circle pb-1 f16 text-info pt-1 pr-2"
                  message={
                    "Check the box to enable/disable, and click and drag the left handleto reorder your dashboard. Click 'Display configuration' to configure which metrics will show in each section."
                  }
                  inline={true}
                />{" "}
                <span className=" f16 text-info ">What does this mean?</span>
              </div>
              <div className="d-flex flex-column ">
                <Form.Check
                  className="f16"
                  name="ob-dash-custom"
                  custom
                  label="I will use the default configuration"
                  type="radio"
                  id="ob-dash-custom-no"
                  onClick={() => {
                    setShowBoxes(false);
                    setValidatation(true);
                    props.setPpcDefault(true)
                  }}
                />
                <Form.Check
                  name="ob-dash-custom"
                  className="f16"
                  custom
                  label="I want to customize my dashboard layout now"
                  type="radio"
                  id="ob-dash-custom-yes"
                  onClick={() => {
                    setShowBoxes(true);
                    setValidatation(true);
                    props.setPpcDefault(false)
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row className="mt-4 mb-2">
            <Col md={11}>
              <p className="f14 primary">
                Check the boxes to enable/disable sections, and then click and drag dashboard boxes to reorder how they will appear in your performance
                dashboards:
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
      <div className="tab-shadow mask-wrapper">
        {showBoxes === false && <div className="mask"></div>}
        <Tab.Container id="account-config-tabs" defaultActiveKey="all-ppc" activeKey="all-ppc">
          <Nav variant="pills" className="pt-0  pb-0 nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-lg-1 trim-padding">
            <Nav.Item className="col">
              <Nav.Link eventKey="all-ppc" className="tab-titles">
                All PPC
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane className="" eventKey="all-ppc">
              <All ppcDashboard={props.ppcDashboard} setPpcDashboard={props.setPpcDashboard}  {...props} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
      <Row className="mt-5 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <OverlayTrigger placement="top-start" delay={{ show: 150, hide: 400 }} overlay={backTooltip}>
              <Button
                style={{
                  paddingLeft: "85px",
                  paddingRight: "95px",
                  opacity: "50%",
                }}
                className="py-0 f16 nunito-regular nextBtn validated"
                size="md">
                {chevronLeft}
                {` Back`}
              </Button>
            </OverlayTrigger>
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
